/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * A React component for previous icon.
 *
 * @author Hari Gangadharan
 */
const Prev = props => (
  <SvgIcon viewBox="24 28 18 9" {...props}>
    <path
      d="M41.2500844,31.7501875 L26.5602783,31.7501875 L29.0300798,29.2804375 C29.3233359,28.9871875 29.3233359,
      28.5131875 29.0300798,28.2199375 C28.7368237,27.9266875 28.2628138,27.9266875 27.9695577,
      28.2199375 L24.2202296,31.9691875 C24.1849789,32.0044375 24.1534782,32.0434375 24.1257276,
      32.0846875 C24.1137274,32.1019375 24.1062272,32.1214375 24.095727,32.1401875 C24.0822267,
      32.1641875 24.0679764,32.1874375 24.0567262,32.2136875 C24.046976,32.2376875 24.0409759,
      32.2631875 24.0334757,32.2879375 C24.0274756,32.3104375 24.0192254,32.3306875 24.0147253,
      32.3531875 C23.9952249,32.4499375 23.9952249,32.5496875 24.0147253,32.6471875 C24.0192254,
      32.6696875 24.0274756,32.6899375 24.0334757,32.7116875 C24.0409759,32.7371875 24.046976,
      32.7626875 24.0567262,32.7866875 C24.0679764,32.8129375 24.0822267,32.8361875 24.095727,
      32.8601875 C24.1062272,32.8789375 24.1137274,32.8984375 24.1257276,32.9156875 C24.1534782,
      32.9569375 24.1849789,32.9959375 24.2202296,33.0311875 L27.9695577,36.7804375 C28.1158107,
      36.9266875 28.3078147,37.0001875 28.4998187,37.0001875 C28.6918227,37.0001875 28.8838267,
      36.9266875 29.0300798,36.7804375 C29.3233359,36.4871875 29.3233359,36.0131875 29.0300798,
      35.7199375 L26.5602783,33.2501875 L41.2500844,33.2501875 C41.664093,33.2501875 42.0001,
      32.9141875 42.0001,32.5001875 C42.0001,32.0861875 41.664093,31.7501875 41.2500844,31.7501875"
    />
  </SvgIcon>
);

export default Prev;



// WEBPACK FOOTER //
// ./src/js/icons/Prev.jsx